import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import Slider from '../../hocs/Slider/Slider';
import { deepClone } from '../../utils/object';
import s from './ProductImages.scss';

const ProductImages = ({ product, categoryGender }) => {
	useEffect(() => {
		const arrowSVG = '<svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" fill="black" d="M0.462853 3.82843L3.64483 0.646445C3.8401 0.451183 4.15668 0.451183 4.35194 0.646445L7.53392 3.82843C7.72918 4.02369 7.72918 4.34027 7.53392 4.53553C7.33866 4.73079 7.02208 4.73079 6.82681 4.53553L4.49839 2.20711L4.49839 16H3.49839L3.49839 2.20711L1.16996 4.53553C0.974698 4.73079 0.658115 4.73079 0.462853 4.53553C0.267591 4.34027 0.267591 4.02369 0.462853 3.82843Z"></path></svg>';
		let lightbox = new PhotoSwipeLightbox({
			arrowPrevSVG: arrowSVG,
			arrowNextSVG: arrowSVG,
			closeSVG: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13" stroke="black"></path><path d="M1 1L13 13" stroke="black"></path></svg>',
			zoomSVG: '',
			gallery: '#productTop',
			children: '.u-galleryImage',
			showHideAnimationType: 'zoom',
			pswpModule: () => import('photoswipe/dist/photoswipe.esm'),
		});
		lightbox.init();

		return () => {
			lightbox.destroy();
			lightbox = null;
		};
	}, []);

	const mediaSort = product.media.reduce((acc, media) => {
		if (!media?.sources?.jeanMedium) return null;
		if (/[^a-z]woman[^a-z]/i.test(media.sources.jeanMedium.url)) return { ...acc, woman: [...acc.woman, deepClone(media)] };
		if (/[^a-z]man[^a-z]/i.test(media.sources.jeanMedium.url)) return { ...acc, man: [...acc.man, deepClone(media)] };
		return { ...acc, general: [...acc.general, deepClone(media)] };
	}, { woman: [], man: [], general: [] });

	const currentMedia = mediaSort.woman.length > 0 || mediaSort.man.length > 0 ? [...mediaSort[categoryGender], ...mediaSort.general] : mediaSort.general;

	return (
		<Slider screenMaxWidthDisable="600" showCounter={false}>
			{
				currentMedia.map((media, i) => (
					<a key={media.sources.jeanMedium.url} href={media.sources.jeanZoom.url} data-pswp-width={media.sources.jeanZoom.width} data-pswp-height={media.sources.jeanZoom.height} target="_blank" rel="noopener noreferrer" className={['u-galleryImage', s.productImage, (product.film && i === 0 ? s.productImage__film : null)].join(' ')}>
						<img className={s.productImage_image} src={media.sources.jeanMedium.url} width={media.sources.jeanZoom.width} height={media.sources.jeanZoom.height} alt={`${product.brandName} ${product.name}`} />
					</a>
				))
			}
		</Slider>
	);
};

export default hot(module)(ProductImages);
